<template>
  <aside class="main-sidebar sidebar-dark-primary">
    <router-link to="/dashboard" class="brand-link text-center">
      <span class="brand-text font-weight-dark"> {{appShortName}}</span>
    </router-link>
    <div class="sidebar">
      <div class="user-panel mt-3 pb-3 mb-3 d-flex">
        <div class="image"><img :src="auth_user.avatar" class="img-circle elevation-2" alt="User Image"></div>
        <div class="info"><a href="#" class="d-block">{{auth_user.nome}}</a></div>
      </div>
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-toggle="push-menu" data-widget="treeview" role="menu"
          data-accordion="true">
          <li class="nav-item text-white" v-if="auth_user.ambiente !== 'S'">
            <a href="#" @click="$emit('openUpload')"
              style="color:white;background-color:#28a745;border-color:#28a745;box-shadow:none"
              v-if="auth_user.fk_empresa_id && allow('UPLOAD')" class="nav-link">
              <i class="nav-icon fa fa-upload"></i>
              <p>Carregar Documento</p>
            </a>
          </li>
          <li class="nav-item">
            <router-link to="/inbox" class="nav-link">
              <i class="nav-icon fa fa-pencil fa-fw"></i>
              <p>Para eu assinar <span class="right badge badge-warning">{{auth_user.toSign}}</span>
                <p />
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/historico">
              <i class="nav-icon fa fa-history fa-fw"></i>
              <p>Assinados</p>
            </router-link>
          </li>
          <div class="user-panel">
          </div>
          <li class="nav-item" v-if="auth_user.ambiente !== 'S'">
            <router-link to="/home" style="color:black;background-color:#d39e00;border-color:#d39e00;box-shadow:none"
              class="nav-link">
              <i class="nav-icon fa fa-archive"></i>
              <p>Documentos</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/finalizados">
              <i class="nav-icon fa fa-check-circle-o fa-fw"></i>
              <p>Finalizados</p>
            </router-link>
          </li>
          <li v-if="auth_user.ambiente !== 'S'" class="nav-item">
            <router-link class="nav-link" to="/pendentes">
              <i class="nav-icon fa fa-clock-o fa-fw"></i>
              <p>Pendentes</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/expirados">
              <i class="nav-icon fa fa-times-circle-o fa-fw"></i>
              <p>Expirados</p>
            </router-link>
          </li>
          <div class="user-panel">
          </div>
          <!--   <li class="nav-item" v-if="auth_user.ambiente == 'A'">
            <router-link to="/usuarios" class="nav-link">
              <i class="nav-icon fa fa-pencil"></i>
              <p>Assinaturas</p>
            </router-link>
          </li> -->
          <li class="nav-item has-treeview" v-show="auth_user.ambiente !== 'A'"
            v-if="(allow('EMPRESAS') || auth_user.ambiente === 'S') && $route.name !== '451'">
            <a href="#" class="nav-link">
              <i class="nav-icon fa fa-shopping-cart"></i>
              <p>Loja <i class="fa fa-angle-left right"></i></p>
            </a>
            <ul class="nav nav-treeview">
              <li v-if="(empresaLogada.plano && empresaLogada.plano.recorrente)">
                <router-link to="/loja" class="nav-link">
                  <i class="nav-icon fa fa-plus-circle"></i>
                  <p>Adicionais</p>
                </router-link>
              </li>
              <li v-if="(empresaLogada.plano && !empresaLogada.plano.recorrente) || auth_user.ambiente === 'S'">
                <router-link to="/comprar" class="nav-link">
                  <i class="nav-icon fa fa-credit-card"></i>
                  <p>Assinar DocXDigital</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li v-if="auth_user.ambiente != 'S'" class="nav-item has-treeview">
            <a href="#" class="nav-link">
              <i class="nav-icon fa fa-cogs"></i>
              <p>Configuração <i class="fa fa-angle-left right"></i></p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item" v-if="allow('EMPRESAS')">
                <router-link class="nav-link" to="/empresas">
                  <i class="nav-icon fa fa-building fa-fw"></i>
                  <p>{{$t('words.company') }}</p>
                </router-link>
              </li>
              <li class="nav-item" v-if="allow('USUARIOS')">
                <router-link to="/usuarios" class="nav-link">
                  <i class="nav-icon fa fa-users"></i>
                  <p>Usuários</p>
                </router-link>
              </li>
              <li class="nav-item" v-if="allow('PERMISSOES')">
                <router-link to="/cargos" class="nav-link">
                  <i class="nav-icon fa fa-lock fa-fw"></i>
                  <p>Cargos</p>
                </router-link>
              </li>
              <li class="nav-item" v-if="allow('NIVEIS')">
                <router-link to="/niveis" class="nav-link">
                  <i class="nav-icon fa fa-sitemap fa-fw"></i>
                  <p>Níveis</p>
                </router-link>
              </li>
              <li class="nav-item" v-if="allow('AUDITORIA')">
                <router-link to="/auditoria" class="nav-link">
                  <i class="nav-icon fa fa-user-secret fa-fw"></i>
                  <p>Auditoria</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/parametros" class="nav-link">
                  <i class="nav-icon fa fa-wrench"></i>
                  <p>Parâmetros</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li v-if="auth_user.ambiente == 'A'" class="nav-item has-treeview">
            <a href="#" class="nav-link">
              <i class="nav-icon fa fa-wrench"></i>
              <p>Administrativo <i class="fa fa-angle-left right"></i></p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item has-treeview">
                <a href="#" class="nav-link">
                  <i class="nav-icon fa fa-tag"></i>
                  <p>Configurar Planos <i class="fa fa-angle-left right"></i></p>
                </a>
                <ul class="nav nav-treeview">
                  <li class="nav-item">
                    <router-link to="/planos" class="nav-link">
                      <i class="nav-icon fa fa-tag"></i>
                      <p>Planos</p>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/planos-modulo" class="nav-link">
                      <i class="nav-icon fa fa-table"></i>
                      <p>Cadastro de Módulos</p>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/planos-periodo" class="nav-link">
                      <i class="nav-icon fa fa-calendar"></i>
                      <p>Cadastro de Período</p>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/pre-cadastros" class="nav-link">
                      <i class="nav-icon fa fa-clock-o"></i>
                      <p>Pré Cadastros</p>
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <router-link to="/termos" class="nav-link">
                  <i class="nav-icon fa fa-legal"></i>
                  <p>Termos</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/parametros" class="nav-link">
                  <i class="nav-icon fa fa-wrench"></i>
                  <p>Parâmetros</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item text-center" v-if="auth_user.ambiente === 'S' && $route.name !== '451'">
            <router-link to="/experimente-gratis" class="exp text-red nav-link"> {{ $t('words.trial') }} </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/consulta-publica" class="nav-link" target="_blank">
              <i class="nav-icon fa fa-check-circle-o"></i>
              <p>Verificador de Assinatura</p>
            </router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://www.youtube.com/channel/UCZC-ve4TCMkUq4x9qiYnOfQ" target="_blank">
              <i class="nav-icon fa fa-youtube-play text-danger"></i> <p class="px-1 text-underline"> Duvidas</p>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
  export default {
    data() {
      return {
        order: [],
        oldOrder: [],
      }
    },
    computed: {
      plano() {
        return (this.auth_user.empresa.plano) ?
          (this.auth_user.empresa.plano.config.ck_tipo) : this.auth_user.empresa.plano
      }
    },
    beforeMount() {
      this.allow = this.allow.bind(this);
    },
    mounted() {
      $('body').Layout('fixLayoutHeight');
      setTimeout(() => {
        if (this.$router.history._startLocation == '/login') {
          $('[data-widget="treeview"]').Treeview('init');
        }
      }, 300);
    },
  };
</script>

<style rel="stylesheet/scss" lang="scss">
  .navbar-dark {
    border: 0 !important;
  }

  .sl-vue-tree {
    position: relative;
    cursor: default;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
  }

  .sl-vue-tree-root>.sl-vue-tree-nodes-list {
    overflow: visible;
    position: relative;
    padding-bottom: 4px;
  }

  .sl-vue-tree-selected>.sl-vue-tree-node-item {
    background-color: rgba(100, 100, 255, 0.5);
  }

  .sl-vue-tree-node-list {
    position: relative;
    display: flex;
    flex-direction: row;
  }

  .sl-vue-tree-node-item {
    position: relative;
    display: flex;
    flex-direction: row;
    padding: 7px;
  }

  .sl-vue-tree-node-item.sl-vue-tree-cursor-inside {
    outline: 1px solid rgba(100, 100, 255, 0.5);
  }

  .sl-vue-tree-gap {
    width: 20px;
    min-height: 1px;
  }

  .sl-vue-tree-sidebar {
    margin-left: auto;
  }

  .sl-vue-tree-cursor {
    position: absolute;
    border: 1px solid rgba(100, 100, 255, 0.5);
    height: 1px;
    width: 100%;
  }

  .sl-vue-tree-drag-info {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0.5;
    margin-left: 20px;
    margin-bottom: 20px;
    padding: 5px 10px;
  }

  .contextmenu {
    position: absolute;
    background-color: white;
    color: black;
    border-radius: 2px;
    cursor: pointer;
  }

  .contextmenu>ul {
    padding: 10px;
  }

  .contextmenu>ul:hover {
    background-color: rgba(100, 100, 255, 0.5);
  }

  .last-event {
    color: white;
    background-color: rgba(100, 100, 255, 0.5);
    padding: 10px;
    border-radius: 2px;
  }

  .contextmenu {
    margin: 0;
    background: #fff;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: #eee;
      }
    }
  }
</style>